interface IStepperProps {
  steps: string[];
  currentStep: number;
  /** Name every step, not only the current and the next. Off by default so other wizards render as before. */
  showAllLabels?: boolean;
}

const Stepper = ({ steps, currentStep, showAllLabels = false }: IStepperProps) => {
  const progress = ((currentStep + 1) / steps.length) * 100;
  return (
    <div className="pb-3.5 flex flex-col gap-3">
      {/* Steps */}
      <div className={`flex items-center ${showAllLabels ? "gap-3 sm:gap-5" : "gap-5"}`}>
        {steps.map((step: string, index: number) => (
          <div key={step}>
            <div className="flex gap-2 items-center">
              <div
                className={`w-8 h-8 flex items-center text-sm font-semibold leading-[17px] justify-center rounded-lg z-10 ${
                  showAllLabels
                    ? index <= currentStep
                      ? "bg-blue-700 text-white-A700"
                      : "border border-[#6B7280] text-[#6B7280]"
                    : index < currentStep + 1
                      ? "bg-[#EFF4FF] text-blue-700 border-none border border-[#EFF4FF]"
                      : "border border-[#EFF4FF]"
                }`}
              >
                {showAllLabels && index < currentStep ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              {showAllLabels && index !== currentStep && (
                <p
                  className={`text-sm font-medium leading-[16.94px] ${
                    index < currentStep ? "text-blue-700" : "text-[#6B7280]"
                  } sm:hidden`}
                >
                  {step}
                </p>
              )}
              {index === currentStep && (
                <div className={`text-sm text-blue-700 ${showAllLabels ? "font-semibold" : "font-medium"}`}>{step}</div>
              )}
              {!showAllLabels && index > currentStep && index === currentStep + 1 && (
                <p className=" text-sm sm:hidden md:hidden font-medium text-[#999999] leading-[16.94px]">
                  {steps[index]}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Progress bar */}
      <div className="h-1 border-b border-gray-border">
        <div
          className="h-full rounded-lg  bg-blue-600 transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default Stepper;
